export default function Footer() {
  const scrollToSection = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-background-950 text-background-50 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div className="lg:col-span-1">
            <span className="text-xl font-bold font-heading tracking-tight">
              CotIdel<span className="text-accent-500">.</span>
            </span>
            <p className="mt-3 text-sm text-background-400 leading-relaxed">
              La première intelligence experte de cotation infirmière en France.
              Sécurisez votre facturation avec une IA qui raisonne comme un expert NGAP.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">Produit</h4>
            <ul className="space-y-2.5">
              <li><button onClick={() => scrollToSection('how-it-works')} className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">Comment ça marche</button></li>
              <li><button onClick={() => scrollToSection('pourquoi')} className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">Pourquoi CotIdel</button></li>
              <li><button onClick={() => scrollToSection('pricing')} className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">Tarifs</button></li>
              <li><button onClick={() => scrollToSection('faq')} className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">FAQ</button></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">Ressources</h4>
            <ul className="space-y-2.5">
              <li><a href="#" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">Blog</a></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">Documentation</a></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">Veille réglementaire</a></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">Mentions légales</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">Contact</h4>
            <ul className="space-y-2.5">
              <li className="text-sm text-background-400">contact@ici-cotation.fr</li>
              <li className="text-sm text-background-400">France</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} CotIdel - Intelligence de Cotation Infirmière. Tous droits réservés.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-background-500 hover:text-background-200 transition-colors cursor-pointer" aria-label="LinkedIn">
              <i className="ri-linkedin-fill text-lg"></i>
            </a>
            <a href="#" className="text-background-500 hover:text-background-200 transition-colors cursor-pointer" aria-label="X">
              <i className="ri-twitter-x-fill text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}